import { z } from 'zod';
/** Windows the team activity page can show. Each is compared with the window of the same length before it */
export var TeamActivityPeriod;
(function (TeamActivityPeriod) {
    TeamActivityPeriod["LAST_7_DAYS"] = "7d";
    TeamActivityPeriod["LAST_30_DAYS"] = "30d";
    TeamActivityPeriod["LAST_90_DAYS"] = "90d";
    TeamActivityPeriod["THIS_QUARTER"] = "quarter";
})(TeamActivityPeriod || (TeamActivityPeriod = {}));
export const TeamActivityPeriodLabels = {
    [TeamActivityPeriod.LAST_7_DAYS]: `Last 7 days`,
    [TeamActivityPeriod.LAST_30_DAYS]: `Last 30 days`,
    [TeamActivityPeriod.LAST_90_DAYS]: `Last 90 days`,
    [TeamActivityPeriod.THIS_QUARTER]: `This quarter`,
};
export const teamActivityQuerySchema = z.object({
    period: z.nativeEnum(TeamActivityPeriod).default(TeamActivityPeriod.LAST_30_DAYS),
});
//# sourceMappingURL=teamActivity.js.map